import { CompletionContext } from "@codemirror/autocomplete"

export const shouldForceNestedKeyCompletion = (context: CompletionContext) => {
  if (context.explicit) {
    return false
  }

  const line = context.state.doc.lineAt(context.pos)
  const beforeCursor = line.text.slice(0, context.pos - line.from)
  const trimmedBefore = beforeCursor.trim()

  if (!trimmedBefore || trimmedBefore.includes(":")) {
    return false
  }

  const currentIndent = beforeCursor.match(/^\s*/)?.[0].length ?? 0

  for (let lineNumber = line.number - 1; lineNumber >= 1; lineNumber -= 1) {
    const previousLine = context.state.doc.line(lineNumber)
    const previousText = previousLine.text

    if (!previousText.trim()) {
      continue
    }

    const previousIndent = previousText.match(/^\s*/)?.[0].length ?? 0
    if (previousIndent < currentIndent) {
      return previousText.trim().endsWith(":")
    }
  }

  return false
}
